import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={18.652}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 10827 14919"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541813536">
        <path
          d="M7270 0H3557S3383 4361 0 4990h10827C7445 4361 7270 0 7270 0zM0 5836h5112v594c-422 17-1140 181-1140 1096l740 6510c-366 64-1611 325-1611 883h4625c0-558-1245-819-1611-883l740-6510c0-915-718-1079-1140-1096v-594h5112v-495H0v495z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
